module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "vehicle"
    }
  }, [_c('bc-navbar'), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "page_maincontent layout_fullwidth_padding"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "car-top"
  }, [_c('h2', {
    staticClass: "page_title margin_left_none",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.vehicle.year) + " " + _vm._s(_vm.vehicle.make) + " " + _vm._s(_vm.vehicle.modelName) + "\n        " + _vm._s(_vm.vehicle.trim) + "\n      ")]), _vm._v(" "), _c('section', {
    staticClass: "price-section"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.price(_vm.vehicle.offeringPrice)))]), _vm._v(" "), (_vm.hasDealerFees) ? [_c('div', {
    staticClass: "price-row"
  }, [_c('span', [_vm._v("Market")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.price(_vm.vehicle.price)))])]), _vm._v(" "), _vm._l((_vm.vehicle.applicableDealerFees), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "price-row"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.price(item.amount)))])])
  }), _vm._v(" "), _c('hr', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-row summary-price"
  }, [_c('span', [_vm._v("Offering price")]), _vm._v(" "), _c('span', {
    staticClass: "summary-price-value"
  }, [_vm._v(_vm._s(_vm.price(_vm.vehicle.offeringPrice)))])])] : _vm._e(), _vm._v(" "), _c('price-info')], 2), _vm._v(" "), _c('div', {
    staticClass: "car-top-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.vehicle.photos[0],
      "onerror": "this.src='https://vassstorage.blob.core.windows.net/salesraterprod/images/m_no_photo.png'"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "like-btn",
    on: {
      "click": function($event) {
        return _vm.onFavorite({
          vehicleId: _vm.vehicle.id,
          isFavorite: !_vm.vehicle.isFavorite,
        })
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon",
    class: {
      'dbc-icon-heart': _vm.vehicle.isFavorite,
      'dbc-icon-heart-empty': !_vm.vehicle.isFavorite,
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "car-description-container"
  }, [(_vm.vehicle.photos.length > 1) ? _c('a', {
    staticClass: "button_full btgreen",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.switchGallery()
      }
    }
  }, [_c('span', [_vm._v("View All Images")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button_full btn-blue-outlined",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkAvailabilityLink.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("Check Availablity")])]), _vm._v(" "), (_vm.vehicle.testDriveLink) ? _c('a', {
    staticClass: "button_full btn-blue-outlined",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal(_vm.vehicle.testDriveLink)
      }
    }
  }, [_c('span', [_vm._v("Schedule Test Drive")])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.calculePaymentsLink) ? _c('a', {
    staticClass: "button_full btn-blue-outlined",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal(_vm.vehicle.calculePaymentsLink)
      }
    }
  }, [_c('span', [_vm._v("Calculate Payments")])]) : _vm._e(), _vm._v(" "), _c('table', [_c('tr', [_c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("VIN")]), _vm._v(" "), _c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("STOCK #")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.vehicle.saleClass))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.vin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.stockNumber))])])]), _vm._v(" "), (_vm.vehicle.description) ? _c('div', {
    staticClass: "car-desc-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.vehicle.description.substr(0, _vm.minDescriptionLength)))]), _vm._v(" "), (_vm.showMoreDots) ? _c('span', [_vm._v("...")]) : _vm._e(), _vm._v(" "), (_vm.isShowMore && _vm.vehicle.description) ? _c('span', [_vm._v(_vm._s(_vm.vehicle.description.substr(_vm.minDescriptionLength, _vm.vehicle.description.length)))]) : _vm._e(), _vm._v(" "), (_vm.showMoreBtn) ? _c('a', {
    staticClass: "button_full button-white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.showMoreDesc()
      }
    }
  }, [(!_vm.isShowMore) ? _c('span', [_vm._v("SHOW MORE")]) : _vm._e(), _vm._v(" "), (_vm.isShowMore) ? _c('span', [_vm._v("SHOW LESS")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.brochures.length > 0) ? _c('div', {
    staticClass: "brochure-list"
  }, [_c('table', {
    staticClass: "text-left"
  }, [_c('tr', [_c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("Download Brochure")])]), _vm._v(" "), _vm._l((_vm.brochures), function(broc, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {}, [_c('a', {
      staticClass: "external",
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "href": broc.fileUrl,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.openBrochure(broc)
        }
      }
    }, [_vm._v(_vm._s(broc.year) + " " + _vm._s(broc.make) + " " + _vm._s(broc.model) + "\n                " + _vm._s(broc.submodel) + "\n              ")])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "text-left"
  }, [_c('tr', [_c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("CATEGORY")]), _vm._v(" "), _c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("VALUE")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Model")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.modelName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Trim")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.trim))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Year")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.year))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Body")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.bodyStyle))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Engine")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.engine))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Transmission")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.transmission))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Drive Train")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.driveTrain))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Odometer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.odometer))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.fuelEconomy.city))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Highway")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.fuelEconomy.highway))])])]), _vm._v(" "), _c('table', {
    staticClass: "text-left"
  }, [_c('tr', [_c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("KEY FEATURES")])]), _vm._v(" "), _vm._l((_vm.vehicle.dealerOptions), function(option, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {}, [_vm._v(_vm._s(option))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.isLoaded) ? _c('div', {
    staticClass: "loader-container",
    attrs: {
      "color": "#f9f300"
    }
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": "#f9f300"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('f7-popup', {
    ref: "modal",
    staticClass: "widget-modal"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('iframe', {
    attrs: {
      "id": "widget",
      "src": _vm.widgetUrl,
      "frameborder": "0"
    }
  }), _vm._v(" "), (_vm.widgetLoading) ? _c('div', {
    staticClass: "modal-loader"
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": "#f9f300"
    }
  })], 1) : _vm._e()])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d4198da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d4198da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/inventory/vehicle.vue
// module id = 814
// module chunks = 0